import React, { Component } from 'react';

import SectionList from './Section/SectionList';
// import SectionCorner from './Section/SectionCorner';
import SectionBar from './Section/SectionBar';

class SectionMore extends Component {

  render() {

    const { $$data, width } = this.props;

    const align = 'left';

    const barColor = '#fff';

    const listProps = {id: 'more', data: $$data, align, className: 'SectionMore', title: 'C\'est aussi...', titleIcon: 'more', titleColor: '#fff', sectionBg: true, titleSize: width};
    console.log({listProps})
    return (
      <SectionList barColor={barColor} style={this.props.style || {}} {...listProps} footer={<div className="footer" key="ft">
        <SectionBar length={80} color={barColor} direction={'vertical'} style={{marginLeft: 0}}  />
      </div>} forceVisibility={true}/>
  );
}
}

export default SectionMore;



// WEBPACK FOOTER //
// ./src/components/Home/SectionMore.jsx